// PK LOVELY — fiche produit premium (maquette Claude Design « PDP LOVELY »), adaptée au thème.
// Une instance par section [data-pk-lovely]. Aucune écoute de « scroll » pour l'animation :
// IntersectionObserver / ResizeObserver, comme dans la maquette.
// L'ajout au panier passe par <product-form> du thème (assets/theme.js) : tiroir panier, compteur, erreurs.
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  // Les médias des variantes viennent du CDN Bobochic (ou de Shopify), qui acceptent ?width= comme la galerie du thème
  function sized(src, w) {
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$1' + w);
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  // Filet de sécurité : si le CDN Bobochic ne sert pas une image (format léger « data-cdn-format » absent,
  // ou version ?width= en échec), on recharge l'originale thickbox_default plutôt que d'afficher une image cassée
  // (vignettes du hero, pastilles « Modèle »…)
  function unsized(src) {
    return src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
  }
  function retryUnsized(img) {
    var src = img.currentSrc || img.src || '';
    // Deuxième échec (ou image hors CDN) : image Shopify de repli si la vignette en a une (packshots « Modèle »)
    var last = img.getAttribute('data-fallback-src');
    if ((img.__pkUnsized || src.indexOf('cdn.bobochicparis.com') < 0) && last && !img.__pkFallback) {
      img.__pkFallback = true;
      img.removeAttribute('srcset');
      img.src = packshotSrc(last, img);
      return;
    }
    if (img.__pkUnsized || src.indexOf('cdn.bobochicparis.com') < 0) return;
    var fmt = img.getAttribute('data-cdn-format');
    var next = unsized(fmt ? src.replace('-' + fmt + '/', '-thickbox_default/') : src);
    if (next === src) return;
    img.__pkUnsized = true;
    img.removeAttribute('srcset');
    img.src = next;
  }
  // Vidéos du serveur Bobochic plafonnées à 720p (même règle que snippets/pk-lovely-video-src.liquid)
  function capVideo(src) {
    if (String(src).indexOf('videosr2.bobochicparis.com') < 0) return src;
    return src.replace(/([_/])(?:2160|1440|1080)p([._])/, '$1720p$2');
  }
  // Repli : si la version 720p n'existe pas, on recharge la vidéo d'origine (data-video-full)
  function retryFullVideo(video) {
    var full = video.getAttribute('data-video-full');
    if (video.__pkFull || !full || video.getAttribute('src') === full) return;
    video.__pkFull = true;
    var playing = !video.paused || video.autoplay;
    video.src = full;
    if (playing) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
  }

  function watchBrokenImages(wrap) {
    // « error » ne remonte pas : écoute en phase de capture, pour les images ajoutées ensuite par le JS
    wrap.addEventListener('error', function (e) {
      if (e.target.tagName === 'IMG') retryUnsized(e.target);
      else if (e.target.tagName === 'VIDEO') retryFullVideo(e.target);
    }, true);
    // Images déjà en échec avant le chargement du script
    $$('img', wrap).forEach(function (img) { if (img.complete && img.naturalWidth === 0) retryUnsized(img); });
  }

  // srcset des visuels du hero recréés au changement de variante : mêmes largeurs et même « sizes » que le Liquid
  // (snippets/pk-lovely-srcset.liquid, sections/pk-lovely-product.liquid) ; les visuels du CDN font 1200 px au plus
  var HERO_WIDTHS = [400, 600, 800, 1000, 1200];
  var HERO_SIZES = '(max-width: 768px) 100vw, (max-width: 1600px) calc(100vw - 400px), 75vw';
  // deferred : attributs en data-* (diapositive non affichée), posés par hydrateSlide le moment venu
  function heroSrcAttrs(src, deferred) {
    var pre = deferred ? 'data-' : '';
    if (!/cdn\.bobochicparis\.com|cdn\.shopify\.com|\/cdn\/shop\//.test(src)) return pre + 'src="' + esc(src) + '"';
    var set = HERO_WIDTHS.map(function (w) { return sized(src, w) + ' ' + w + 'w'; }).join(', ');
    return pre + 'src="' + esc(sized(src, 1200)) + '" ' + pre + 'srcset="' + esc(set) + '" ' + pre + 'sizes="' + HERO_SIZES + '"';
  }
  // Diapositives du hero : empilées et masquées par opacité, elles sont « à l'écran » pour le navigateur,
  // qui les chargerait toutes (loading="lazy" n'y change rien). Leur image n'est posée qu'à l'approche.
  function hydrateSlide(slide) {
    if (!slide) return;
    $$('img[data-src]', slide).forEach(function (img) {
      var sizes = img.getAttribute('data-sizes'), set = img.getAttribute('data-srcset');
      if (sizes) img.sizes = sizes;
      if (set) img.srcset = set;
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src'); img.removeAttribute('data-srcset'); img.removeAttribute('data-sizes');
    });
  }

  // Vignettes du hero (48 px, carrées) : format medium_default du CDN, qui ignore ?width= ; repli sur thickbox_default (retryUnsized)
  var THUMB_FORMAT = 'medium_default';
  function thumbUrl(src) {
    return sized(src.replace('-thickbox_default/', '-' + THUMB_FORMAT + '/'), 200);
  }

  function packshotSrc(src, img) {
    var fmt = img.getAttribute('data-cdn-format');
    if (fmt) src = src.replace('-thickbox_default/', '-' + fmt + '/');
    var w = parseInt(img.getAttribute('data-src-width'), 10);
    return w ? sized(src, w) : src;
  }

  function init(wrap) {
    if (wrap.__pkLovely) return;
    wrap.__pkLovely = true;
    watchBrokenImages(wrap);
    var root = $('.pp', wrap);
    var dataEl = $('script[data-pk-lovely-json]', wrap);
    if (!root || !dataEl) return;
    var DATA = JSON.parse(dataEl.textContent);
    var STR = DATA.strings || {};
    wrap.classList.add('pp-js');

    function isMobile() { return root.classList.contains('is-mobile'); }
    function syncWidth() {
      root.classList.toggle('is-mobile', root.clientWidth <= 768);
      root.classList.toggle('is-compact', root.clientWidth <= 1279);
    }
    // Sections sous le hero (atouts) : mise en page mobile jusqu'à la tablette comprise
    function isCompact() { return root.classList.contains('is-compact'); }
    syncWidth();
    if (window.ResizeObserver) new ResizeObserver(syncWidth).observe(root);

    // ---------- Variantes ----------
    var form = $('product-form form', wrap);
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var current = DATA.variants.filter(function (v) { return v.id === DATA.selected; })[0] || DATA.variants[0];
    var selected = current ? current.options.slice() : [];

    function findVariant(opts) {
      return DATA.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }
    // Option choisie sans combinaison existante : on garde la valeur cliquée et on prend la première variante qui la contient
    function closestVariant(index, value) {
      var exact = findVariant(selected.map(function (o, i) { return i === index ? value : o; }));
      if (exact) return exact;
      return DATA.variants.filter(function (v) { return v.options[index] === value; })[0];
    }
    function variantLabel(v) { return v ? v.options.join(' · ') : ''; }

    function renderOptions() {
      $$('[data-option-index]', wrap).forEach(function (b) {
        var i = +b.getAttribute('data-option-index');
        var on = b.getAttribute('data-option-value') === selected[i];
        b.classList.toggle('is-selected', on);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        // Pastille estompée si la combinaison avec les autres options choisies est épuisée
        var probe = findVariant(selected.map(function (o, k) { return k === i ? b.getAttribute('data-option-value') : o; }));
        b.classList.toggle('is-soldout', !!probe && !probe.available);
      });
      $$('[data-option-name]', wrap).forEach(function (el) {
        el.textContent = selected[+el.getAttribute('data-option-name')] || '';
      });
      fitSwatches();
    }

    // Pastilles de la buybox (modèle, matière) sur une seule ligne : celles qui passeraient à la ligne sont masquées,
    // le bouton « + » donne accès à toutes. La pastille sélectionnée reste toujours visible.
    function fitSwatches() {
      $$('.pp-buy .pp-opt__swatches', wrap).forEach(function (box) {
        var items = Array.prototype.slice.call(box.children);
        if (!items.length) return;
        items.forEach(function (el) { el.hidden = false; });
        if (!box.offsetWidth) return; // buybox repliée ou pas encore mise en page
        var top = items[0].offsetTop;
        var wraps = function (el) { return el.offsetTop > top + 1; };
        items.forEach(function (el) { if (wraps(el)) el.hidden = true; });
        var sel = box.querySelector('.is-selected');
        if (sel && sel.hidden) {
          sel.hidden = false;
          for (var k = items.length - 1; k >= 0 && wraps(sel); k--) {
            if (items[k] !== sel && !items[k].hidden) items[k].hidden = true;
          }
        }
      });
    }
    if (window.ResizeObserver) {
      var swatchRO = new ResizeObserver(function () { fitSwatches(); });
      $$('.pp-buy .pp-opt__row', wrap).forEach(function (row) { swatchRO.observe(row); });
    }

    function renderVariant(v, pushUrl) {
      if (!v) return;
      current = v;
      selected = v.options.slice();
      if (idInput) idInput.value = v.id;
      renderOptions();
      $$('[data-variant-label]', wrap).forEach(function (el) { el.textContent = variantLabel(v); });
      $$('[data-price]', wrap).forEach(function (el) {
        el.textContent = v.price;
        el.classList.toggle('pp-price--sale', !!v.compare);
      });
      $$('[data-compare-price]', wrap).forEach(function (el) { el.textContent = v.compare || ''; el.hidden = !v.compare; });
      $$('[data-instalments]', wrap).forEach(function (el) { if (STR.instalments && v.instalment) el.innerHTML = STR.instalments.replace('__AMOUNT__', v.instalment); });
      $$('[data-delivery]', wrap).forEach(function (el) {
        el.innerHTML = v.delivery || ''; // HTML rendu par Liquid (snippets/pk-delivery-message.liquid, dates en gras)
        var li = el.closest('li'); if (li) li.hidden = !v.delivery;
      });
      // Statut de stock (« classe|libellé », même logique que le bloc inventaire de la fiche standard)
      var stock = (v.stock || '').split('|');
      $$('[data-stock]', wrap).forEach(function (el) {
        el.textContent = stock[1] || '';
        el.className = 'pp-stock pp-stock--' + (stock[0] || '');
        var li = el.closest('[data-stock-row]'); if (li) li.hidden = stock.length < 2;
      });
      var prop = form ? form.querySelector('[data-delivery-property]') : null;
      if (prop) { prop.value = v.deliveryProperty || ''; prop.disabled = !v.deliveryProperty; }
      $$('[data-add]', wrap).forEach(function (b) {
        b.disabled = !v.available;
        b.textContent = v.available ? STR.addToCart : STR.soldOut;
      });
      // Le packshot garde la largeur demandée côté Liquid (data-src-width) au lieu de l'image pleine taille
      $$('[data-variant-image]', wrap).forEach(function (img) { if (v.image) { img.__pkUnsized = false; img.__pkFallback = false; img.removeAttribute('data-fallback-src'); img.src = packshotSrc(v.image, img); } });
      // Les pastilles « Modèle » mènent à la même couleur et au même angle sur la fiche sœur
      // et leur packshot (custom.media_flyout) suit la couleur et l'angle
      $$('[data-model-variants]', wrap).forEach(function (a) {
        var map = JSON.parse(a.getAttribute('data-model-variants') || '{}');
        var entry = map[selected.join('|')] || [];
        var base = a.getAttribute('data-model-url');
        a.href = base + (entry[0] ? (base.indexOf('?') > -1 ? '&' : '?') + 'variant=' + entry[0] : '');
        var img = $('[data-model-packshot]', a);
        if (img && entry[1]) {
          img.__pkUnsized = false; img.__pkFallback = false;
          if (entry[2]) img.setAttribute('data-fallback-src', entry[2]); else img.removeAttribute('data-fallback-src');
          img.src = packshotSrc(entry[1], img);
        }
      });
      renderTexture(selected[0]);
      renderHero(v.medias);
      if (pushUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    // Le tissu, au plus près : le fond et la loupe prennent la texture de la couleur choisie
    var textureKey = '';
    var fabricWave = null; // rendu WebGL du tissu en mouvement (voir « Matières : tissu en mouvement »)
    function renderTexture(color) {
      var tex = (DATA.textures || {})[color];
      if (!tex || !tex.src || tex.src === textureKey) return;
      var first = textureKey === '';
      textureKey = tex.src;
      var surface = $('[data-fabric-surface]', root);
      if (surface) {
        if (tex.w) surface.setAttribute('data-img-w', tex.w);
        if (tex.h) surface.setAttribute('data-img-h', tex.h);
      }
      if (first) return; // texture initiale déjà posée côté Liquid
      // Version mobile (800 px) sous 768 px, comme la media query de pk-lovely.css
      var src = isMobile() && tex.srcM ? tex.srcM : tex.src;
      var apply = function () {
        wrap.style.setProperty('--pp-fabric-img-d', 'url("' + tex.src + '")');
        wrap.style.setProperty('--pp-fabric-img-m', 'url("' + (tex.srcM || tex.src) + '")');
        if (surface) surface.classList.remove('is-changing');
        if (fabricWave) fabricWave.load(src);
      };
      if (!surface || reduce || fabricWave) { apply(); return; }
      // Fondu : on précharge la texture puis on la pose
      surface.classList.add('is-changing');
      var img = new Image();
      img.onload = img.onerror = apply;
      img.src = src;
    }

    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-option-index]');
      if (!b || !wrap.contains(b)) return;
      var v = closestVariant(+b.getAttribute('data-option-index'), b.getAttribute('data-option-value'));
      if (v) renderVariant(v, true);
    });

    // ---------- Quantité ----------
    var qty = 1;
    var qtyEl = $('[data-qty]', wrap), qtyInput = form ? form.querySelector('input[name="quantity"]') : null, dec = $('[data-qty-dec]', wrap), inc = $('[data-qty-inc]', wrap);
    function renderQty() {
      if (qtyEl) qtyEl.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
      if (dec) { dec.classList.toggle('is-disabled', qty <= 1); dec.setAttribute('aria-disabled', qty <= 1 ? 'true' : 'false'); }
    }
    if (dec) dec.addEventListener('click', function () { if (qty > 1) { qty--; renderQty(); } });
    if (inc) inc.addEventListener('click', function () { qty++; renderQty(); });

    // ---------- Panier : erreurs renvoyées par <product-form> du thème ----------
    var errEl = $('[data-cart-error]', wrap);
    if (form) {
      form.addEventListener('cart:error', function (e) { if (errEl) errEl.textContent = (e.detail && e.detail.error) || ''; });
      form.addEventListener('variant:add', function () { if (errEl) errEl.textContent = ''; });
    }
    // Le bouton de la barre d'achat soumet le formulaire de la buybox
    $$('[data-add-proxy]', wrap).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!form) return;
        if (form.requestSubmit) form.requestSubmit($('[data-add]', form) || undefined); else $('[data-add]', form).click();
      });
    });

    var heroEl = $('.pp-hero', root);

    // ---------- Fil d'Ariane : déplacé de sa section (placée juste après la fiche) en tête de buybox ----------
    var crumbSlot = $('[data-buy-crumb]', root);
    function moveCrumb() {
      var sec = wrap.closest('.shopify-section'), next = sec && sec.nextElementSibling;
      var nav = next && next.classList.contains('shopify-section--pk-breadcrumb') ? $('.pk-breadcrumb', next) : null;
      if (!crumbSlot || !nav) return;
      crumbSlot.innerHTML = '';
      crumbSlot.appendChild(nav);
    }
    moveCrumb();
    // Éditeur de thème : la section du fil d'Ariane, rechargée, revient à sa place
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.classList && e.target.classList.contains('shopify-section--pk-breadcrumb')) moveCrumb();
    });

    // ---------- Hero : film puis médias de la variante, en carrousel ----------
    var stage = $('[data-hero-stage]', root);
    var thumbsEl = $('[data-hero-thumbs]', root);
    var dotsEl = null, dots = [], loopClone = null;
    var slides = [], thumbs = [], cur = 0, heroVisible = true, heroKey = '', heroPoster = '';
    function heroMedias(medias) {
      // Même ordre que le Liquid : la photo principale d'abord, le film produit en 2e position
      var list = (medias || []).slice();
      if (DATA.film) list.splice(list.length ? 1 : 0, 0, { type: 'video', src: DATA.film, film: true });
      return list;
    }
    function slideHtml(m, i) {
      var alt = esc(STR.mediaAlt + ' ' + (i + 1));
      if (m.film) {
        // Même rendu que le Liquid : poster en image, film attaché par attachFilm
        return '<div class="pp-slide" data-slide="' + i + '" aria-hidden="true">' +
          (heroPoster ? '<img class="pp-slide__img pp-hero__poster" draggable="false" ' + heroSrcAttrs(heroPoster, i > 0) + ' alt="">' : '') +
          '<video class="pp-hero__video" data-film-src="' + esc(capVideo(m.src)) + '" data-video-full="' + esc(m.src) + '" muted loop playsinline preload="none" aria-hidden="true"></video></div>';
      }
      if (m.type === 'video') {
        return '<div class="pp-slide" data-slide="' + i + '" aria-hidden="true"><video class="pp-hero__video" src="' + esc(capVideo(m.src)) + '" data-video-full="' + esc(m.src) + '" muted loop playsinline preload="' + (i === 0 ? 'auto' : 'none') + '" aria-hidden="true"></video></div>';
      }
      return '<div class="pp-slide pp-slide--photo" data-slide="' + i + '" aria-hidden="true"><img class="pp-slide__img" draggable="false" ' + heroSrcAttrs(m.src, i > 0) + ' alt="' + alt + '"></div>';
    }
    function thumbHtml(m, i, poster) {
      var label = m.type === 'video' ? STR.video : STR.photo + ' ' + (i + 1);
      var thumbSrc = m.type === 'video' ? poster : m.src;
      var img = thumbSrc ? '<img src="' + esc(thumbUrl(thumbSrc)) + '" data-cdn-format="' + THUMB_FORMAT + '" alt="" loading="lazy">' : '';
      var play = m.type === 'video' ? '<span class="pp-thumb__play" aria-hidden="true">' + DATA.playIcon + '</span>' : '';
      return '<button class="pp-thumb' + (m.type === 'video' ? ' pp-thumb--video' : '') + '" type="button" role="tab" aria-selected="false" data-slide-to="' + i + '" aria-label="' + esc(label) + '">' + img + play + '</button>';
    }
    // Mobile : le hero est un carrousel à défilement natif (scroll-snap, pk-lovely.css). La diapositive affichée
    // suit le défilement (≥ 60 % visible) ; les voisines reçoivent leur image à l'approche.
    var heroIO = null, heroNearIO = null;
    function observeHeroScroll() {
      if (heroIO) heroIO.disconnect();
      if (heroNearIO) heroNearIO.disconnect();
      if (!window.IntersectionObserver) return;
      heroIO = new IntersectionObserver(function (en) {
        if (!isMobile()) return;
        en.forEach(function (x) {
          var k = x.target === loopClone ? 0 : slides.indexOf(x.target);
          if (x.isIntersecting && k > -1 && k !== cur) goSlide(k, false, true);
        });
      }, { root: stage, threshold: 0.6 });
      heroNearIO = new IntersectionObserver(function (en) {
        if (!isMobile()) return;
        en.forEach(function (x) { if (x.isIntersecting) hydrateSlide(x.target); });
      }, { root: stage, rootMargin: '0px 50%' });
      slides.forEach(function (sl) { heroIO.observe(sl); heroNearIO.observe(sl); });
      if (loopClone) heroIO.observe(loopClone);
    }
    function bindHero() {
      slides = $$('[data-slide]', stage);
      // Mobile : boucle sans fin. Une copie de la 1re photo suit la dernière ; une fois le défilement posé dessus,
      // on revient sans animation sur la vraie 1re (même image, rien ne bouge à l'écran) : on balaie indéfiniment
      var oldClone = $('[data-slide-clone]', stage);
      if (oldClone) oldClone.remove();
      loopClone = null;
      if (slides.length > 1) {
        loopClone = slides[0].cloneNode(true);
        loopClone.removeAttribute('data-slide');
        loopClone.setAttribute('data-slide-clone', '');
        loopClone.setAttribute('aria-hidden', 'true');
        loopClone.classList.add('pp-slide--clone');
        loopClone.classList.remove('is-active');
        $$('video', loopClone).forEach(function (v) { v.removeAttribute('src'); v.removeAttribute('data-film-src'); });
        slides[slides.length - 1].insertAdjacentElement('afterend', loopClone);
      }
      // Bande horizontale (desktop) : chaque visuel est décalé de sa position par rapport au visuel affiché
      slides.forEach(function (s, k) { s.style.setProperty('--k', k); });
      thumbs = thumbsEl ? $$('[data-slide-to]', thumbsEl) : [];
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goSlide(+t.getAttribute('data-slide-to')); }); });
      $$('video', stage).forEach(function (v) { v.muted = true; });
      var controls = $('.pp-hero__controls', root);
      if (controls) controls.hidden = slides.length < 2;
      // Desktop au repos : calque de points posé sur la rangée de vignettes (fondu croisé au survol, pk-lovely.css)
      if (thumbsEl) {
        dotsEl = $('[data-hero-dots]', root);
        if (!dotsEl) {
          dotsEl = document.createElement('div');
          dotsEl.className = 'pp-hero__dots';
          dotsEl.setAttribute('data-hero-dots', '');
          dotsEl.setAttribute('aria-hidden', 'true');
          thumbsEl.parentNode.insertBefore(dotsEl, thumbsEl.nextSibling);
        }
        dotsEl.innerHTML = slides.map(function () { return '<span class="pp-hero__dot"></span>'; }).join('');
        dots = $$('.pp-hero__dot', dotsEl);
      }
      observeHeroScroll();
    }
    function renderHero(medias) {
      if (!stage) return;
      var list = heroMedias(medias);
      var key = JSON.stringify(list);
      if (key === heroKey) return;
      var first = heroKey === '';
      heroKey = key;
      if (first && slides.length) return; // rendu initial déjà fait côté Liquid
      var poster = heroPoster = (list.filter(function (m) { return m.type === 'image'; })[0] || {}).src || '';
      $$('[data-slide]', stage).forEach(function (s) { s.remove(); });
      var scrim = $('.pp-hero__scrim', stage);
      scrim.insertAdjacentHTML('beforebegin', list.map(slideHtml).join(''));
      if (thumbsEl) thumbsEl.innerHTML = list.map(function (m, i) { return thumbHtml(m, i, poster); }).join('');
      bindHero();
      goSlide(0);
    }
    // Film du hero (2e diapositive) : sa vidéo n'est attachée que lorsqu'on affiche sa diapositive ; le poster
    // reste visible jusqu'à ce qu'elle joue. Rien avec « réduire les animations » : le poster reste affiché.
    function attachFilm(slide) {
      var v = slide ? $('video[data-film-src]', slide) : null;
      if (!v || reduce || v.getAttribute('src')) return;
      v.addEventListener('playing', function () { v.classList.add('is-ready'); }, { once: true });
      v.preload = 'auto';
      v.src = v.getAttribute('data-film-src');
    }
    // Vignettes : rangée défilante (5 visibles en desktop) ; la vignette affichée passe en tête,
    // les précédentes sont poussées vers la gauche
    function syncThumbStrip() {
      var t = thumbs[cur];
      if (!thumbsEl || !t || thumbsEl.scrollWidth <= thumbsEl.clientWidth) return;
      var first = thumbs[0], step = thumbs.length > 1 ? thumbs[1].offsetLeft - first.offsetLeft : t.offsetWidth;
      var fit = Math.max(1, Math.floor((thumbsEl.clientWidth + 1) / step));
      var lead = thumbs[Math.max(0, Math.min(cur, thumbs.length - fit))];
      thumbsEl.scrollTo({ left: lead.offsetLeft - first.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    function activeVideo() { var s = slides[cur]; return s ? $('video', s) : null; }
    function playHero() {
      var v = activeVideo();
      if (!v || reduce || !heroVisible || !v.getAttribute('src')) return; // film pas encore attaché
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    var heroBrowsed = false; // le visiteur a changé de diapositive : on précharge aussi les voisines
    // fromScroll : appel venu du défilement natif (mobile), on ne refait pas défiler le carrousel
    function goSlide(i, focusThumb, fromScroll) {
      var n = slides.length; if (!n) return;
      var next = (i + n) % n;
      if (next !== cur) heroBrowsed = true;
      cur = next;
      if (isMobile() && !fromScroll && slides[cur] && Math.abs(stage.scrollLeft - slides[cur].offsetLeft) > 1) {
        stage.scrollTo({ left: slides[cur].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      }
      hydrateSlide(slides[cur]);
      attachFilm(slides[cur]);
      stage.style.setProperty('--cur', cur);
      if (heroBrowsed) { hydrateSlide(slides[(cur + 1) % n]); hydrateSlide(slides[(cur - 1 + n) % n]); }
      slides.forEach(function (s, k) {
        var on = k === cur;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        var v = $('video', s); if (v && !on) v.pause();
      });
      thumbs.forEach(function (t, k) {
        var on = k === cur;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === cur); });
      syncThumbStrip();
      // Barre de position (mobile) : nombre de diapositives et rang affiché
      var bar = $('[data-hero-bar]', root);
      if (bar) {
        bar.hidden = n < 2;
        bar.style.setProperty('--pp-slides', n);
        bar.style.setProperty('--pp-slide', cur);
      }
      if (focusThumb && thumbs[cur]) thumbs[cur].focus({ preventScroll: true });
      playHero();
    }
    if (stage) {
      bindHero();
      heroKey = current ? JSON.stringify(heroMedias(current.medias)) : '';
      if (thumbsEl) thumbsEl.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goSlide(cur + 1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goSlide(cur - 1, true); }
      });
      var sp = $('[data-slide-prev]', root), sn = $('[data-slide-next]', root);
      if (sp) sp.addEventListener('click', function () { goSlide(cur - 1); });
      if (sn) sn.addEventListener('click', function () { goSlide(cur + 1); });
      // Balayage horizontal (tactile ou souris) sur le fond du hero
      var swipeX = null, swiped = false;
      stage.addEventListener('pointerdown', function (e) { swipeX = e.clientX; swiped = false; });
      stage.addEventListener('pointerup', function (e) {
        if (swipeX === null || isMobile()) { swipeX = null; return; } // mobile : défilement natif
        var dx = e.clientX - swipeX; swipeX = null;
        if (Math.abs(dx) > 48) { swiped = true; goSlide(cur + (dx < 0 ? 1 : -1)); }
      });
      stage.addEventListener('pointercancel', function () { swipeX = null; });
      stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
      // Boucle mobile : arrivé sur la copie de la 1re photo (défilement posé), retour instantané sur la vraie
      var loopTimer = 0;
      stage.addEventListener('scroll', function () {
        if (!loopClone || !isMobile()) return;
        clearTimeout(loopTimer);
        loopTimer = setTimeout(function () {
          if (Math.abs(stage.scrollLeft - loopClone.offsetLeft) > 2) return;
          stage.scrollTo({ left: slides[0].offsetLeft, behavior: 'instant' });
        }, 80);
      }, { passive: true });

      // Desktop : clic sur le visuel = mode agrandi (la buybox sort à droite, le visuel prend toute la largeur) ;
      // le cadrage vertical suit alors la souris (haut de l'écran = haut de la photo)
      var reopen = $('[data-buy-reopen]', root);
      var isExpanded = function () { return !!heroEl && heroEl.classList.contains('is-expanded'); };
      var setExpanded = function (on) {
        if (!heroEl || (on && isMobile())) return;
        // Les vignettes passent du bas à gauche au bas centre de l'écran : glissement animé (FLIP),
        // le changement de colonne de la grille ne s'anime pas en CSS
        var ctrls = $('.pp-hero__controls', heroEl);
        var x0 = ctrls ? ctrls.getBoundingClientRect().left : 0;
        heroEl.classList.toggle('is-expanded', on);
        if (ctrls && !reduce && ctrls.animate) {
          var dx = x0 - ctrls.getBoundingClientRect().left;
          if (dx) ctrls.animate([{ transform: 'translateX(' + dx + 'px)' }, { transform: 'none' }], { duration: 500, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
        }
        wrap.classList.toggle('pp-hero-expanded', on);
        stage.style.setProperty('--pp-pan-y', '50%');
        // Pas de focus forcé sur le bouton de rappel : ouvert à la souris, il afficherait l'anneau de focus
        if (reopen) reopen.hidden = !on;
      };
      stage.addEventListener('click', function (e) {
        if (swiped || e.target.closest('button, a')) return;
        if (isMobile()) { if (Date.now() - lastTap > 700) openViewer(cur); return; }
        setExpanded(!isExpanded());
      });
      // Mobile : le toucher est aussi détecté directement (doigt levé sans glisser), sans attendre un « click »
      // que certains navigateurs mobiles ne déclenchent pas sur un carrousel à défilement natif
      var tapX = 0, tapY = 0, tapT = 0, lastTap = 0;
      stage.addEventListener('pointerdown', function (e) { tapX = e.clientX; tapY = e.clientY; tapT = Date.now(); }, { passive: true });
      stage.addEventListener('pointerup', function (e) {
        if (!isMobile() || !tapT || e.pointerType === 'mouse') return;
        var still = Math.abs(e.clientX - tapX) < 10 && Math.abs(e.clientY - tapY) < 10 && Date.now() - tapT < 500;
        tapT = 0;
        if (!still || e.target.closest('button, a')) return;
        lastTap = Date.now();
        openViewer(cur);
      }, { passive: true });

      // Mobile : touché sur le visuel = visionneuse plein écran (PhotoSwipe du thème, importmap « vendor » /
      // « photoswipe ») : pincer pour zoomer / dézoomer, balayer pour changer de visuel, vignettes en bas.
      // Chargée au premier touché seulement.
      var viewer = null;
      var loadModule = function (name) { return window.importShim ? window.importShim(name) : import(name); };
      var viewerItems = function () {
        return slides.map(function (s, k) {
          var v = $('video', s), im = $('.pp-slide__img:not(.pp-hero__poster)', s) || $('.pp-hero__poster', s);
          // Film ou vidéo : lu dans la visionneuse (pas de zoom) ; « réduire les animations » : son image d'aperçu
          if (v && !(reduce && im)) {
            // Même source que le hero (720p, ou l'originale si le hero a déjà dû y revenir) ; data-video-full : repli
            var full = v.getAttribute('data-video-full') || '';
            var vsrc = (v.__pkFull && full) || v.getAttribute('data-film-src') || v.getAttribute('src') || full;
            return { html: '<div class="pp-pswp__video"><video src="' + esc(vsrc) + '" data-video-full="' + esc(full) + '" muted loop playsinline controls preload="metadata"></video></div>' };
          }
          if (!im) return { html: '' };
          var src = im.getAttribute('data-src') || im.getAttribute('src') || '';
          return {
            src: /[?&]width=\d+/.test(src) ? sized(src, 1200) : src,
            srcset: im.getAttribute('data-srcset') || im.getAttribute('srcset') || '',
            msrc: im.currentSrc || '',
            width: parseInt(im.getAttribute('width'), 10) || 1200,
            height: parseInt(im.getAttribute('height'), 10) || 900,
            alt: im.alt || ''
          };
        });
      };
      var registerViewerUi = function () {
        var pswp = viewer.pswp;
        pswp.ui.registerElement({
          name: 'pp-close', order: 20, isButton: true, appendTo: 'root',
          className: 'pp-btn pp-btn--white pp-btn--icon pp-pswp__close',
          title: STR.close || '',
          html: '<img class="icon" src="' + esc(DATA.closeIcon || '') + '" alt="" aria-hidden="true" width="24" height="24">',
          onClick: function () { pswp.close(); }
        });
        if (pswp.getNumItems() < 2) return;
        pswp.ui.registerElement({
          name: 'pp-thumbs', order: 21, appendTo: 'root', tagName: 'div',
          onInit: function (el) {
            el.className = 'pp-pswp__thumbs';
            el.setAttribute('role', 'tablist');
            el.setAttribute('aria-label', STR.gallery || '');
            el.innerHTML = thumbs.map(function (t, k) {
              var ti = $('img', t);
              return '<button class="pp-pswp__thumb" type="button" role="tab" aria-label="' + esc(t.getAttribute('aria-label') || '') + '" data-pswp-to="' + k + '">' +
                (ti ? '<img src="' + esc(ti.currentSrc || ti.src) + '" alt="">' : '') +
                ($('.pp-thumb__play', t) ? '<span class="pp-thumb__play" aria-hidden="true">' + DATA.playIcon + '</span>' : '') + '</button>';
            }).join('');
            var btns = $$('[data-pswp-to]', el);
            btns.forEach(function (b) { b.addEventListener('click', function () { pswp.goTo(+b.getAttribute('data-pswp-to')); }); });
            var sync = function () {
              btns.forEach(function (b, k) {
                var on = k === pswp.currIndex;
                b.classList.toggle('is-active', on);
                b.setAttribute('aria-selected', on ? 'true' : 'false');
                if (on) el.scrollTo({ left: b.offsetLeft - (el.clientWidth - b.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
              });
            };
            pswp.on('change', sync);
            sync();
          }
        });
      };
      var playViewerVideo = function () {
        var pswp = viewer && viewer.pswp; if (!pswp) return;
        var cur = pswp.currSlide && pswp.currSlide.container;
        $$('video', pswp.element).forEach(function (vid) {
          vid.muted = true;
          if (cur && cur.contains(vid)) { var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else vid.pause();
        });
      };
      var openViewer = function (index) {
        if (viewer && viewer.pswp) return; // déjà ouverte
        // PhotoSwipe exposé par le module de la section (window.pkLovelyPswp) ; à défaut, import direct
        var lib = window.pkLovelyPswp ? Promise.resolve(window.pkLovelyPswp) : loadModule('vendor').then(function (mod) {
          return { PhotoSwipeLightbox: mod.PhotoSwipeLightbox, module: function () { return loadModule('photoswipe'); } };
        });
        lib.then(function (mod) {
          if (!viewer) {
            viewer = new mod.PhotoSwipeLightbox({
              pswpModule: mod.module,
              // Ajoutée au <body> (hors des conteneurs de la fiche) ; la classe pk-lovely lui donne les tokens
              mainClass: 'pk-lovely pp-pswp',
              bgOpacity: 1,
              showHideAnimationType: reduce ? 'none' : 'fade',
              initialZoomLevel: 'fit',
              secondaryZoomLevel: 2,
              maxZoomLevel: 4,
              // Place des vignettes en bas et du bouton fermer en haut
              paddingFn: function () { return { top: 64, bottom: slides.length > 1 ? 88 : 24, left: 0, right: 0 }; },
              arrowPrev: false, arrowNext: false, counter: false, close: false, zoom: false,
              // Un toucher simple ne masque plus l'interface (fermer, vignettes) ; double toucher / pincer = zoom
              tapAction: function () {},
              closeTitle: STR.close || ''
            });
            viewer.on('uiRegister', registerViewerUi);
            // Visionneuse hors de la fiche : même repli que la fiche pour les images et vidéos en échec (720p absente…)
            viewer.on('afterInit', function () { watchBrokenImages(viewer.pswp.element); playViewerVideo(); });
            // Seule la vidéo affichée joue (muette au départ, en boucle, comme dans le hero)
            viewer.on('change', playViewerVideo);
            // Contrôles natifs de la vidéo (lecture, pause, son, avance) : sur la vidéo, PhotoSwipe garde ses gestes
            // (balayage pour changer de visuel) mais n'annule plus les événements du navigateur, qui restent aux contrôles
            viewer.addFilter('preventPointerEvent', function (prevent, e) {
              return e && e.target && e.target.closest && e.target.closest('.pp-pswp__video video') ? false : prevent;
            });
            // À la fermeture, le carrousel de la fiche se cale sur le dernier visuel vu
            viewer.on('close', function () { if (viewer.pswp) goSlide(viewer.pswp.currIndex); });
            viewer.init();
          }
          viewer.loadAndOpen(index, viewerItems());
        }).catch(function (err) { if (window.console) console.error('[pk-lovely] visionneuse', err); });
      };
      stage.addEventListener('mousemove', function (e) {
        if (!isExpanded()) return;
        var r = stage.getBoundingClientRect();
        var y = Math.max(0, Math.min(1, (e.clientY - r.top) / r.height));
        stage.style.setProperty('--pp-pan-y', (y * 100).toFixed(1) + '%');
      });
      if (reopen) reopen.addEventListener('click', function (e) {
        setExpanded(false);
        // Activé au clavier (detail = 0) : le focus passe dans la buybox revenue
        if (e.detail === 0) { var add = $('.pp-buy [data-add]', root); if (add) add.focus({ preventScroll: true }); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isExpanded()) setExpanded(false); });
      // Passage en mobile : on quitte le mode agrandi
      if (window.ResizeObserver) new ResizeObserver(function () { if (isMobile() && isExpanded()) setExpanded(false); }).observe(root);

      goSlide(0);
      // Desktop : la diapositive suivante attend derrière la buybox, on ne la charge qu'à l'intention
      // (survol ou focus des flèches et vignettes, début de balayage) ; une vignette survolée charge son visuel.
      // Mobile : les voisines sont déjà chargées à l'approche par le défilement natif (observeHeroScroll).
      var warmNext = function () { if (slides.length > 1) hydrateSlide(slides[(cur + 1) % slides.length]); };
      var warmThumb = function (e) {
        if (isMobile()) return;
        var t = e.target.closest ? e.target.closest('[data-slide-to]') : null;
        if (t) hydrateSlide(slides[+t.getAttribute('data-slide-to')]);
        warmNext();
      };
      var heroCtrls = $('.pp-hero__controls', root);
      if (heroCtrls) {
        heroCtrls.addEventListener('pointerover', warmThumb, { passive: true });
        heroCtrls.addEventListener('focusin', warmThumb);
      }
      stage.addEventListener('pointerdown', function () { if (!isMobile()) warmNext(); }, { passive: true });
      // Le film se met en pause quand le hero n'est plus à l'écran
      if (window.IntersectionObserver) new IntersectionObserver(function (en) {
        en.forEach(function (x) { heroVisible = x.isIntersecting; if (heroVisible) playHero(); else { var v = activeVideo(); if (v) v.pause(); } });
      }, { threshold: 0.05 }).observe(stage);
    }

    // Hauteur de la barre d'achat sticky : le visuel collant des atouts se cale dessous
    var barEl = $('[data-bar]', wrap);
    if (barEl && window.ResizeObserver) new ResizeObserver(function () { wrap.style.setProperty('--pp-bar-h', barEl.offsetHeight + 'px'); }).observe(barEl);

    // ---------- Atouts : l'image suit l'atout lu (défilement, survol, clic) ----------
    var feats = $$('[data-story]', root);
    var storyImgs = $$('[data-story-img]', root);
    var storyLock = 0;
    function storyLocked() { return storyLock === Infinity || Date.now() < storyLock; }
    function setStory(i) {
      feats.forEach(function (f) {
        var on = f.getAttribute('data-story') === String(i);
        f.classList.toggle('is-active', on);
        var b = $('.pp-feat__btn', f); if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      storyImgs.forEach(function (im) { im.classList.toggle('is-active', im.getAttribute('data-story-img') === String(i)); });
      syncClips();
    }

    // ---------- Atouts : extraits vidéo en boucle (début / fin réglés sur le bloc) ----------
    // Desktop : seul l'extrait de l'atout actif joue ; mobile : l'extrait prend la place de la photo de son atout
    // et joue quand il est à l'écran. Rien ne joue si l'utilisateur a demandé à réduire les animations.
    var clips = $$('[data-clip]', root);
    function syncClips() {
      (clips || []).forEach(function (v) {
        var want = !reduce && v._ppVisible && (isCompact() || v.classList.contains('is-active'));
        if (want) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
      });
    }
    clips.forEach(function (v) {
      var start = parseFloat(v.getAttribute('data-clip-start')) || 0, end = parseFloat(v.getAttribute('data-clip-end')) || 0;
      v.muted = true;
      var rewind = function () { v.currentTime = start; syncClips(); };
      v.addEventListener('loadedmetadata', function () { if (v.currentTime < start) v.currentTime = start; });
      v.addEventListener('timeupdate', function () { if ((end && v.currentTime >= end) || v.currentTime < start - 0.5) rewind(); });
      v.addEventListener('ended', rewind);
      if (window.IntersectionObserver) new IntersectionObserver(function (en) { v._ppVisible = en[0].isIntersecting; syncClips(); }, { threshold: 0.2 }).observe(v);
      else v._ppVisible = true;
      // Mobile : l'extrait passe dans la vignette de son atout ; desktop : il revient dans le cadre de gauche
      var home = v.parentNode, slot = $('.pp-feat[data-story="' + v.getAttribute('data-story-img') + '"] .pp-feat__img', root);
      function place() {
        if (!slot) return;
        var mob = isCompact();
        if (mob && v.parentNode !== slot) slot.appendChild(v);
        else if (!mob && v.parentNode !== home) home.appendChild(v);
      }
      place();
      if (window.ResizeObserver) new ResizeObserver(function () { place(); syncClips(); }).observe(root);
    });
    feats.forEach(function (f) {
      var i = f.getAttribute('data-story');
      var b = $('.pp-feat__btn', f);
      if (!b) return;
      b.addEventListener('click', function () { setStory(i); });
      b.addEventListener('mouseenter', function () { if (!isCompact() && !storyLocked()) setStory(i); });
      b.addEventListener('focus', function () { if (!storyLocked()) setStory(i); });
    });
    if (window.IntersectionObserver && feats.length) {
      var storyIO = new IntersectionObserver(function (en) {
        if (isCompact() || storyLocked()) return;
        en.forEach(function (x) { if (x.isIntersecting) setStory(x.target.getAttribute('data-story')); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      feats.forEach(function (f) { storyIO.observe(f); });
    }

    // ---------- Avance-recule : la vidéo joue le mouvement demandé puis s'arrête sur la position finale ----------
    $$('[data-motion]', root).forEach(function (m) {
      var vids = {}; $$('[data-motion-video]', m).forEach(function (v) { vids[v.getAttribute('data-motion-video')] = v; v.muted = true; });
      var btns = $$('[data-motion-go]', m).concat($$('[data-motion-remote] [data-motion-go]', root)), label = $('[data-motion-state]', m), busy = false;
      var storyIndex = (m.closest('[data-story-img]') || m).getAttribute('data-story-img') || '0';
      function sync() {
        var st = m.getAttribute('data-state');
        btns.forEach(function (b) { b.disabled = busy || b.getAttribute('data-motion-go') === st; });
      }
      function setFill(b, v) { b.style.setProperty('--p', v); }
      // Chargement différé : les vidéos (≈ 1 Mo chacune, preload="none" côté Liquid) ne se téléchargent
      // qu'à l'approche de la section, ou au premier clic ; seuls les posters partent au chargement de la page
      var warmed = false;
      function warm() {
        if (warmed) return;
        warmed = true;
        Object.keys(vids).forEach(function (k) { vids[k].preload = 'auto'; vids[k].load(); });
      }
      if (window.IntersectionObserver) {
        var warmIO = new IntersectionObserver(function (en) {
          if (en.some(function (e) { return e.isIntersecting; })) { warmIO.disconnect(); warm(); }
        }, { rootMargin: '100% 0px' });
        warmIO.observe(m);
      } else warm();
      function go(dir) {
        var v = vids[dir]; if (!v || busy || m.getAttribute('data-state') === dir) return;
        warm();
        setStory(storyIndex); storyLock = Infinity;
        var on = btns.filter(function (b) { return b.getAttribute('data-motion-go') === dir; });
        busy = true; sync();
        btns.forEach(function (b) { b.classList.toggle('is-playing', on.indexOf(b) > -1); setFill(b, 0); });
        m.classList.add('is-playing');
        if (label) label.textContent = dir === 'avance' ? STR.motionForwarding : STR.motionBackwarding;
        Object.keys(vids).forEach(function (k) { vids[k].classList.toggle('is-active', k === dir); if (k !== dir) vids[k].pause(); });
        var raf = null;
        function tick() {
          if (v.duration) on.forEach(function (b) { setFill(b, Math.min(1, v.currentTime / v.duration)); });
          raf = requestAnimationFrame(tick);
        }
        function done() {
          v.removeEventListener('ended', done);
          if (raf) cancelAnimationFrame(raf);
          busy = false; storyLock = Date.now() + 2500; m.setAttribute('data-state', dir);
          if (label) label.textContent = dir === 'avance' ? STR.motionForward : STR.motionBackward;
          btns.forEach(function (b) { b.classList.remove('is-playing'); setFill(b, 0); });
          m.classList.remove('is-playing');
          sync();
        }
        if (reduce) { try { v.currentTime = v.duration || 99; } catch (err) {} done(); return; }
        v.currentTime = 0;
        v.addEventListener('ended', done);
        var p = v.play();
        if (p && p.then) p.then(tick, function () { done(); }); else tick();
      }
      btns.forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); go(b.getAttribute('data-motion-go')); }); });
      sync();
      // Mobile : la vidéo prend la place de la photo du premier atout ; desktop : elle revient à gauche
      var home = m.parentNode, slot = $('.pp-feat[data-story="' + storyIndex + '"] .pp-feat__img', root);
      function place() {
        if (!slot) return;
        var mob = isCompact();
        if (mob && m.parentNode !== slot) slot.appendChild(m);
        else if (!mob && m.parentNode !== home) home.insertBefore(m, home.firstChild);
      }
      place();
      if (window.ResizeObserver) new ResizeObserver(place).observe(root);
    });

    var surface = $('[data-fabric-surface]', root);

    // ---------- Matières : tissu en mouvement ----------
    // La texture est rendue dans un <canvas> WebGL et déformée par une houle lente (somme de sinusoïdes),
    // avec un ombrage calculé sur la normale de la surface : le tissu semble onduler comme une étoffe drapée.
    // Repli sur l'image CSS statique si WebGL est indisponible, si la texture ne peut pas être lue (CORS)
    // ou si l'utilisateur a demandé à réduire les animations. Le rendu s'arrête hors de l'écran.
    if (surface && !reduce) fabricWave = (function () {
      var canvas = document.createElement('canvas');
      canvas.className = 'pp-fabric__wave';
      canvas.setAttribute('aria-hidden', 'true');
      var gl = canvas.getContext('webgl', { alpha: true, antialias: false, premultipliedAlpha: true });
      if (!gl) return null;
      var VS = 'attribute vec2 p;varying vec2 v;void main(){v=p*.5+.5;gl_Position=vec4(p,0.,1.);}';
      var FS = [
        'precision mediump float;',
        'varying vec2 v;uniform sampler2D a,b;uniform float t,mixv,ar;uniform vec2 sa,sb;',
        // Hauteur de l'étoffe : trois plis lents qui se croisent
        'float h(vec2 q){',
        '  return .55*sin(dot(q,vec2(.82,.57))*2.2+t*.45)',
        '       +.30*sin(dot(q,vec2(-.45,.89))*3.4-t*.33+1.7)',
        '       +.15*sin(dot(q,vec2(.97,-.24))*5.6+t*.52+.4);',
        '}',
        'vec4 tex(sampler2D s,vec2 sc,vec2 uv){return texture2D(s,(uv-.5)*sc+.5);}',
        'void main(){',
        '  vec2 q=vec2(v.x*ar,v.y);float e=.004;',
        '  vec2 g=vec2(h(q+vec2(e,0.))-h(q-vec2(e,0.)),h(q+vec2(0.,e))-h(q-vec2(0.,e)))/(2.*e);',
        '  vec2 uv=vec2(v.x,1.-v.y)+g*vec2(1.,-1.)*.01;',
        '  vec4 c=mix(tex(a,sa,uv),tex(b,sb,uv),mixv);',
        '  vec3 n=normalize(vec3(-g*.45,1.));',
        '  float d=dot(n,normalize(vec3(-.45,.55,.7)));',
        '  float s=clamp(1.+(d-.69)*1.15+.05*h(q),.68,1.18);',
        '  gl_FragColor=vec4(c.rgb*s,c.a);',
        '}'
      ].join('\n');
      function sh(type, src) { var o = gl.createShader(type); gl.shaderSource(o, src); gl.compileShader(o); return gl.getShaderParameter(o, gl.COMPILE_STATUS) ? o : null; }
      var vs = sh(gl.VERTEX_SHADER, VS), fs = sh(gl.FRAGMENT_SHADER, FS);
      if (!vs || !fs) return null;
      var prog = gl.createProgram();
      gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
      if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return null;
      gl.useProgram(prog);
      var buf = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buf);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
      var loc = gl.getAttribLocation(prog, 'p');
      gl.enableVertexAttribArray(loc);
      gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
      var U = {};
      ['a', 'b', 't', 'mixv', 'ar', 'sa', 'sb'].forEach(function (k) { U[k] = gl.getUniformLocation(prog, k); });
      gl.uniform1i(U.a, 0); gl.uniform1i(U.b, 1);
      function mkTex() {
        var tx = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, tx);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        return tx;
      }
      // Deux unités de texture : « a » = texture affichée, « b » = nouvelle texture en fondu
      var slots = [{ tx: mkTex(), w: 1, h: 1 }, { tx: mkTex(), w: 1, h: 1 }];
      var cur = 0, mixv = 0, fadeFrom = 0, ready = false, visible = false, raf = 0, t0 = performance.now(), pending = '';
      // Équivalent de background-size: cover, légèrement agrandi pour que la déformation ne découvre pas les bords
      function cover(slot) {
        var W = canvas.width || 1, H = canvas.height || 1, k = Math.max(W / slot.w, H / slot.h) * 1.04;
        return [W / (slot.w * k), H / (slot.h * k)];
      }
      function upload(slot, img) {
        gl.bindTexture(gl.TEXTURE_2D, slot.tx);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);
        slot.w = img.naturalWidth || 1; slot.h = img.naturalHeight || 1;
      }
      function fail() { cancelAnimationFrame(raf); raf = 0; if (canvas.parentNode) canvas.parentNode.removeChild(canvas); api.load = function () {}; }
      function resize() {
        var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
        var w = Math.round(surface.clientWidth * dpr), h = Math.round(surface.clientHeight * dpr);
        if (w && h && (w !== canvas.width || h !== canvas.height)) { canvas.width = w; canvas.height = h; gl.viewport(0, 0, w, h); }
      }
      function frame(now) {
        raf = 0;
        if (!ready || !visible) return;
        var t = (now - t0) / 1000;
        if (fadeFrom) { mixv = Math.min(1, (now - fadeFrom) / 700); if (mixv >= 1) { cur = 1 - cur; mixv = 0; fadeFrom = 0; } }
        var A = slots[cur], B = slots[1 - cur];
        gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, A.tx);
        gl.activeTexture(gl.TEXTURE1); gl.bindTexture(gl.TEXTURE_2D, B.tx);
        gl.uniform1f(U.t, t); gl.uniform1f(U.mixv, mixv);
        gl.uniform1f(U.ar, canvas.width / canvas.height);
        gl.uniform2fv(U.sa, cover(A)); gl.uniform2fv(U.sb, cover(B));
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        raf = requestAnimationFrame(frame);
      }
      function kick() { if (!raf && ready && visible) raf = requestAnimationFrame(frame); }
      var api = {
        load: function (src) {
          if (!src || src === pending) return;
          pending = src;
          var img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function () {
            if (pending !== src) return;
            try {
              if (!ready) { upload(slots[cur], img); upload(slots[1 - cur], img); ready = true; surface.classList.add('is-waving'); }
              else {
                if (fadeFrom) { cur = 1 - cur; fadeFrom = 0; mixv = 0; }
                upload(slots[1 - cur], img); fadeFrom = performance.now();
              }
            } catch (err) { fail(); return; } // texture non lisible (CORS) : on garde l'image statique
            kick();
          };
          img.onerror = function () { if (!ready) fail(); };
          img.src = src;
        }
      };
      canvas.addEventListener('webglcontextlost', function (e) { e.preventDefault(); surface.classList.remove('is-waving'); fail(); });
      surface.insertBefore(canvas, surface.firstChild);
      resize();
      if (window.ResizeObserver) new ResizeObserver(function () { resize(); kick(); }).observe(surface);
      if (window.IntersectionObserver) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; kick(); }).observe(surface);
      else visible = true;
      var initial = (getComputedStyle(wrap).getPropertyValue('--pp-fabric-img') || '').match(/url\(["']?([^"')]+)["']?\)/);
      if (initial) api.load(initial[1]);
      return api;
    })();

    // ---------- Dimensions : onglets ----------
    $$('[data-dim-tab]', root).forEach(function (t) {
      t.addEventListener('click', function () {
        var k = t.getAttribute('data-dim-tab');
        $$('[data-dim-tab]', root).forEach(function (o) {
          var on = o === t;
          o.classList.toggle('is-active', on);
          o.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        $$('[data-dim]', root).forEach(function (p) { p.hidden = p.getAttribute('data-dim') !== k; });
      });
    });

    // ---------- Informations produit : accordéons ----------
    $$('[data-accordion] .acc-trigger', root).forEach(function (t) {
      t.addEventListener('click', function () { t.setAttribute('aria-expanded', String(t.getAttribute('aria-expanded') !== 'true')); });
    });

    // ---------- Barre d'achat : visible quand le hero (buybox comprise) est passé ----------
    var bar = $('[data-bar]', wrap);
    if (bar && heroEl && window.IntersectionObserver) {
      new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          var show = !x.isIntersecting && x.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          $$('button, a', bar).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
        });
      }).observe(heroEl);
    }

    // ---------- Apparitions au défilement ----------
    var reveals = $$('[data-reveal]', root);
    if (window.IntersectionObserver && !reduce) {
      var rio = new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); rio.unobserve(x.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      reveals.forEach(function (r) { rio.observe(r); });
    } else reveals.forEach(function (r) { r.classList.add('is-in'); });

    // ---------- Panneaux latéraux : modèles de la collection, matière et couleur ----------
    function panel(modal, backdrop, opener, animated) {
      if (!modal || !backdrop) return null;
      var last = null;
      function open() {
        last = document.activeElement;
        modal.hidden = false; backdrop.hidden = false;
        if (animated) requestAnimationFrame(function () { modal.classList.add('is-open'); backdrop.classList.add('is-open'); });
        var sel = $('.is-selected', modal) || $('[data-panel-close]', modal);
        if (sel) sel.focus({ preventScroll: true });
      }
      function close() {
        if (modal.hidden) return;
        if (animated) {
          modal.classList.remove('is-open'); backdrop.classList.remove('is-open');
          setTimeout(function () { modal.hidden = true; backdrop.hidden = true; }, 250);
        } else { modal.hidden = true; backdrop.hidden = true; }
        if (last && last.focus) last.focus({ preventScroll: true });
      }
      $$(opener, root).forEach(function (b) { b.addEventListener('click', open); });
      $$('[data-panel-close]', modal).forEach(function (b) { b.addEventListener('click', close); });
      backdrop.addEventListener('click', close);
      return close;
    }
    var closeStyle = panel($('[data-style-drawer]', wrap), $('[data-style-backdrop]', wrap), '[data-style-open]', false);
    var mModal = $('[data-material-modal]', wrap);
    var closeMaterial = panel(mModal, $('[data-material-backdrop]', wrap), '[data-material-open]', true);
    // Un coloris choisi dans le panneau ferme le panneau après un court instant
    if (mModal && closeMaterial) mModal.addEventListener('click', function (e) {
      if (e.target.closest('[data-option-index]')) setTimeout(closeMaterial, 240);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (closeStyle) closeStyle();
      if (closeMaterial) closeMaterial();
    });

    renderVariant(current, false);
    renderQty();
  }

  function boot() { $$('[data-pk-lovely]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Éditeur de thème : la section est rechargée sans recharger la page
  document.addEventListener('shopify:section:load', function (e) { $$('[data-pk-lovely]', e.target).forEach(init); });
})();
